// Adds .revealed to [data-reveal] elements as they enter the viewport.
// Elements can set data-reveal-delay (ms) for staggered entrances.
// Watches for nodes added later (React renders) via MutationObserver.
export function initScrollReveal() {
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll("[data-reveal]").forEach((node) => node.classList.add("revealed"));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const delay = Number(entry.target.dataset.revealDelay || 0);
        setTimeout(() => entry.target.classList.add("revealed"), delay);
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
  );

  const watch = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches?.("[data-reveal]")) io.observe(root);
    root.querySelectorAll?.("[data-reveal]").forEach((node) => io.observe(node));
  };

  watch(document.body);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach(watch));
  }).observe(document.body, { childList: true, subtree: true });
}
